export default __webpack_public_path__ + "static/media/semplicita-catasto.79d45c39.png";